interface Cookie {
  enableMessage: string;
  mediaOverlayClass: string;
  notice: HTMLElement | null;
  statistic: HTMLInputElement | null;
  personal: HTMLInputElement | null;
  set(cname: string, cvalue: string, exdays: number): void;
  get(cname: string): string;
  init(): void;
  selectAllAndConfirm(): void;
  hideCookiesBox(): void;
  checkSettings(): void;
  allowScripts(): void;
  allowIframes(): void;
  disabledIFrames(): void;
}

const Cookie: Cookie = {
  enableMessage: 'Bitte Cookies zustimmen, um diesen Inhalt anzuzeigen.',
  mediaOverlayClass: 'cookies-info-overlay',
  notice: null,
  statistic: null,
  personal: null,

  set: function (cname: string, cvalue: string, exdays: number): void {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + '; path=/';
  },

  get: function (cname: string): string {
    const name = cname + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(name) === 0) return c.substring(name.length,c.length);
    }
    return "";
  },

  init: function (): void {
    this.notice = document.querySelector('#notice');
    this.statistic = this.notice?.querySelector('#cookies-statistic') as HTMLInputElement;
    this.personal = this.notice?.querySelector('#cookies-personalization') as HTMLInputElement;

    if (this.notice) {
      this.notice.querySelector('.button-check-all')?.addEventListener('click', () => {
        this.selectAllAndConfirm();
        this.hideCookiesBox();
      });

      this.notice.querySelector('.button-confirm')?.addEventListener('click', () => {
        this.set('cookiesAccepted', '1', 30);

        if (this.statistic?.checked) {
          this.set('cookiesStatisticAccepted', '1', 30);
          this.allowScripts();
        }

        if (this.personal?.checked) {
          this.set('cookiesPersonalisationAccepted', '1', 30);
          this.allowIframes();
        }

        this.hideCookiesBox();
      });

      this.checkSettings();
    }
  },

  selectAllAndConfirm: function (): void {
    if (this.statistic) this.statistic.checked = true;
    if (this.personal) this.personal.checked = true;

    this.set('cookiesAccepted', '1', 30);
    this.set('cookiesStatisticAccepted', '1', 30);
    this.allowScripts();
    this.set('cookiesPersonalisationAccepted', '1', 30);
    this.allowIframes();
  },

  hideCookiesBox: function (): void {
    if (this.notice) {
      this.notice.style.opacity = '0';

      setTimeout(() => {
        if (this.notice) {
          this.notice.style.visibility = 'hidden';
          this.notice.style.display = "none";
        }
      }, 500);
    }
  },

  checkSettings: function (): void {
    if (this.get('cookiesAccepted')) {
      if (this.get('cookiesStatisticAccepted')) {
        if (this.statistic) this.statistic.checked = true;
        this.allowScripts();
      }
      if (this.get('cookiesPersonalisationAccepted')) {
        if (this.personal) this.personal.checked = true;
        this.allowIframes();
      } else {
        this.disabledIFrames();
      }
    } else {
      if (this.notice) {
        this.notice.style.visibility = 'visible';
        this.notice.style.opacity = '1';
        this.notice.style.display = "block";
      }
      this.disabledIFrames();
    }
  },

  allowScripts: function (): void {
    for (const script of document.scripts) {
      if (script.type.toLowerCase() === 'text/plain') {
        const clonedScript = script.cloneNode(true) as HTMLScriptElement;
        const oldType = clonedScript.getAttribute('data-type');
        if (oldType) {
          clonedScript.setAttribute('type', oldType);
        } else {
          clonedScript.removeAttribute('type');
        }
        clonedScript.removeAttribute('data-type');
        script.parentNode?.replaceChild(clonedScript, script);
      }
    }
  },

  allowIframes: function (): void {
    const messages = Array.from(document.querySelectorAll(`.${this.mediaOverlayClass}`));
    if (messages.length > 0) {
      messages.forEach((message) => {
        message.parentNode?.removeChild(message);
      });
    }
    const iframes = Array.from(document.querySelectorAll('iframe'));
    if (iframes.length > 0) {
      iframes.forEach((iframe) => {
        iframe.style.display = 'block';
        const url = iframe.getAttribute('data-src');
        if (url) iframe.setAttribute('src', url);
      });
    }
  },

  disabledIFrames: function (): void {
    const pTag = document.createElement('p');
    pTag.innerHTML = this.enableMessage;
    pTag.classList.add(`${this.mediaOverlayClass}-text`);
    const divTag = document.createElement('div');
    divTag.classList.add(this.mediaOverlayClass);
    divTag.appendChild(pTag);

    const iframes = Array.from(document.querySelectorAll('iframe'));
    if (iframes.length > 0) {
      iframes.forEach((iframe) => {
        iframe.parentNode?.insertBefore(divTag.cloneNode(true), iframe);
        iframe.style.display = 'none';
        if (iframe.getAttribute('src')) {
          iframe.setAttribute('src', '');
        }
      });
    }

    const texts = [].slice.call(document.querySelectorAll('.' + this.mediaOverlayClass + '-text'));
    if (texts.length > 0) {
      texts.forEach((overlayText) => {
        (overlayText as HTMLElement).addEventListener('click', () => {
          if (this.notice) {
            this.notice.style.display = "block";
            setTimeout(() => {
              if (this.notice) {
                this.notice.style.visibility = 'visible';
                this.notice.style.opacity = '1';
              }
            }, 1);
          }
        });
      });
    }
  },
};

export default Cookie;
